import React, { useState, useEffect } from "react";
import { PublicUserInfo } from "../../../../Auth/Helper";
import About from "./About";
import Sidebar from "./Sidebar";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import { userPermissions } from "../../../../../Utils/constants";

export default function VendorRole({ setIsProfileEditing }) {
  const { details: userDetails, permissions } = useSelector(
    (state) => state.user
  );
  const { userid } = useParams();
  const userId = userid ? userid : userDetails?.userId;

  const [details, setDetails] = useState({
    about: "",
    industry: "",
    industryExperience: "",
    username: "",
    name: "",
    email: "",
    location: "",
    state: "",
    country: "",
    linkedin: "",
    phone: "",
    website: "",
    profilePhoto: null,
    city: "",
  });
  const navigate = useNavigate();

  useEffect(() => {
    PublicUserInfo({ userId: userId })
      .then((res) => {
        setDetails({
          ...details,
          about: res?.data?.result?.about,
          industry: res?.data?.result?.industry,
          industryExperience: res?.data?.result?.industryExperience,
          username: res?.data?.result?.username,
          email: res?.data?.result?.email,
          firstName: res?.data?.result?.firstName,
          lastName: res?.data?.result?.lastName,
          location: res?.data?.result?.address,
          state: res?.data?.result?.state,
          country: res?.data?.result?.country,
          linkedin: res?.data?.result?.linkedin,
          phone: res?.data?.result?.phone,
          website: res?.data?.result?.website,
          profilePhoto: res?.data?.result?.profilePhoto,
          name: `${res?.data?.result?.firstName ?? ""} ${
            res?.data?.result?.lastName ?? ""
          }`.trim(),
          city: res?.data?.result?.city,
          company: res?.data?.result?.company,
          createdAt: res?.data?.result?.createdAt,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  return (
    <div className={`font-[Roboto] ${userid && "p-8"} bg-neutral-100`}>
      <div className="">
        <div className="flex lg:flex-row flex-col">
          <div className="flex w-[100%] flex-col bg-white">
            <div
              style={{
                height: "155px",
                left: "291px",
                top: "145px",
                background: "#2EBAA3",
                borderRadius: "8px",
                padding: "1rem",
              }}
            ></div>
            <div className="flex flex-row pr-12 pb-12 sm:justify-start justify-center">
              <div>
                {details.profilePhoto ? (
                  <div className="flex sm:justify-start -mt-12 md:mx-0 mx-auto md:ml-8 justify-center h-48 w-48">
                    <img src={details.profilePhoto} alt="profilephoto" />
                  </div>
                ) : (
                  <div className="flex sm:justify-start -mt-12 md:mx-0 mx-auto md:ml-8 justify-center h-48 w-48 bg-blue-600">
                    <div className="flex items-center mx-auto">
                      <span className="text-4xl text-white">
                        {details?.username?.split("")?.[0]?.toUpperCase()}
                      </span>
                    </div>
                  </div>
                )}
                <div className="flex flex-col sm:justify-start  justify-center md:ml-8 mt-4 ">
                  <div className="flex md:mx-0 mx-auto flex-col sm:text-start text-center">
                    <span>{details?.company}</span>
                    <span className="mt-1 text-xs">
                      {"Joined : " +
                        moment(details?.createdAt).format("DD/MM/YYYY")}
                    </span>
                  </div>
                  <div className="flex-col flex md:flex-row sm:flex-col md:mx-0 mx-auto mt-2 md:space-x-2">
                    {details?.website && (
                      <Link
                        target="_blank"
                        to={
                          details?.website.split(":")[0] === "https"
                            ? details?.website
                            : "https://" + details?.website
                        }
                      >
                        <button
                          className="sm:mt-0 mt-4"
                          style={{
                            width: "191px",
                            height: "50px",
                            border: "2px solid #139588",
                            borderRadius: "5px",
                            color: "#139588",
                          }}
                        >
                          Visit Website
                        </button>
                      </Link>
                    )}
                    {userId === localStorage.getItem("userId") &&
                    (permissions?.includes(`admin-vendor`) ||
                      (permissions?.includes(userPermissions.myAccount.edit)) ? (
                        <button
                          className="sm:mt-0 mt-4 text-sm space-x-8 px-2"
                          onClick={() => {
                            navigate("/dashboard/my-account/edit");
                          }}
                          style={{
                            width: "191px",
                            height: "50px",
                            background: "#139588",
                            borderRadius: "5px",
                            color: "white",
                          }}
                        >
                          Edit Profile
                        </button>
                      ) : null)}
                    {userId !== localStorage.getItem("userId") && (
                      <button
                        className="sm:mt-0 mt-4"
                        style={{
                          width: "191px",
                          height: "50px",
                          background: "#139588",
                          borderRadius: "25px",
                          color: "white",
                        }}
                      >
                        Invite
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <Sidebar details={details} />
            </div>
          </div>
        </div>
        <About details={details} />
      </div>
    </div>
  );
}
